import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { productionTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/planning-operations-core/production-targets/')({
  validateSearch: zodValidator(productionTargetsSearchSchema)
});